module.exports = __webpack_public_path__ + "img/no-team-pic.32d9e8d4.png";